module.exports = __webpack_public_path__ + "img/back02_img.0f8a5449.png";